export const GET_VEHICLE_PUBLIC_DATA = 'GET_VEHICLE_PUBLIC_DATA';
export const GET_VEHICLE_PUBLIC_DATA_SUCCESS = 'GET_VEHICLE_PUBLIC_DATA_SUCCESS';
export const GET_VEHICLE_PUBLIC_DATA_ERROR = 'GET_VEHICLE_PUBLIC_DATA_ERROR';

export const PUT_WORK_ORDER_PUBLIC_DATA = 'PUT_WORK_ORDER_PUBLIC_DATA';
export const PUT_WORK_ORDER_PUBLIC_DATA_SUCCESS = 'PUT_WORK_ORDER_PUBLIC_DATA_SUCCESS';
export const PUT_WORK_ORDER_PUBLIC_DATA_ERROR = 'PUT_WORK_ORDER_PUBLIC_DATA_ERROR';